import { createTheme  } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import DataContextProvider from "./context/DataContext";
// import { Helmet } from "react-helmet";
import AuthContextProvider from "./context/AuthContext";
import Routes from "./routes/routes";
// import Head from "./components/Head";
import FunctionsContextProvider from "./context/FunctionsContext";
import { useState } from "react";

function App() {
  console.warn=()=>{}
  const [height,setHeight] = useState()
  const theme = createTheme ({
    palette: {
      primary: {
        main: `#1fa2ad`,
        light: `rgb(84, 222, 232,0.2)`,
        dark: `#ddf8fa`,
      },
    },
    typography: {
      fontFamily: `"Typo Round", sans-serif`,
      button: {
        fontFamily: `"Poppins", sans-serif`,
      },
      body1: {
        fontFamily: `"Poppins", sans-serif`,
      },
      body2: {
        fontFamily: `"Poppins", sans-serif`,
      },
    },
  });
  return (
    <AuthContextProvider>
      <DataContextProvider>
        <FunctionsContextProvider>
          <BrowserRouter>
            <div>
              <ThemeProvider theme={theme}>
                <Header setHeight={setHeight} />
                <div className="outer d-flex flex-column" style={{paddingTop: height}}>
                  <div className="inner w-100">
                    <Routes />
                  </div>
                  <Footer />
                </div>
              </ThemeProvider>
            </div>
          </BrowserRouter>
        </FunctionsContextProvider>
      </DataContextProvider>
    </AuthContextProvider>
  );
}

export default App;
